module.exports = __webpack_public_path__ + "static/media/food-icon.e5027dd6.svg";